
/*----------------------
       SLIDER
---------------------- */
Slider = {
    reducedMotionQuery: window.matchMedia("(prefers-reduced-motion: reduce)"),
    zoomItems: [],
    zoomFrame: null,

    init: function () {
        if ($(".swiper-sliderbig .swiper-slide").length > 1) {
            var swiper = new Swiper(".swiper-sliderbig", {
                effect: "fade",
                loop: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
            });
        }

        Slider.initImageZoom();
    },

    initImageZoom: function () {
        Slider.zoomItems = Array.from(document.querySelectorAll("[data-home-slider][data-imgzoom] img"));

        if (Slider.zoomItems.length) Slider.bindImageZoom();

        if (!Slider.zoomItems.length || Slider.reducedMotionQuery.matches) {
            Slider.zoomItems.forEach(function (image) {
                image.style.setProperty("--home-slider-image-scale", "1");
            });
            return;
        }

        Slider.updateImageZoom();
    },

    updateImageZoom: function () {
        Slider.zoomFrame = null;

        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        Slider.zoomItems.forEach(function (image) {
            const rect = image.getBoundingClientRect();
            const animationDistance = viewportHeight + rect.height * 0.5;
            const progress = Math.min(1, Math.max(0, (viewportHeight - rect.top) / animationDistance));
            const scale = 1.2 - progress * 0.2;

            image.style.setProperty("--home-slider-image-scale", scale.toFixed(4));
        });
    },

    requestImageZoomUpdate: function () {
        if (Slider.zoomFrame || Slider.reducedMotionQuery.matches) return;

        Slider.zoomFrame = window.requestAnimationFrame(Slider.updateImageZoom);
    },

    bindImageZoom: function () {
        if (Slider.imageZoomBound) return;

        window.addEventListener("scroll", Slider.requestImageZoomUpdate, { passive: true });
        window.addEventListener("resize", Slider.requestImageZoomUpdate);

        if (Slider.reducedMotionQuery.addEventListener) {
            Slider.reducedMotionQuery.addEventListener("change", Slider.initImageZoom);
        } else {
            Slider.reducedMotionQuery.addListener(Slider.initImageZoom);
        }

        Slider.imageZoomBound = true;
    }
};

$(document).ready(function () {
    Slider.init();
});
$(document).on('shopify:section:load', function (event) {
    Slider.init();
});
